import React, {Component} from "react";
import {I18n} from "../../../I18n/components/promoter";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {SUPER_ADMIN, USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import PromoterCategoryList from "./PromoterCategoryList";
import PromoterCategoryModal from "./PromoterCategoryModal";
import promoterValidator from "../../../helpers/promoterValidator";
import CommonValidator from "../../../helpers/CommonValidator";
import {
    fetchPromoterCategories,
    removePromoterCategory,
    saveNewPromoterCategory,
    updateSinglePromoterCategory
} from "../../../actions/promoter/promoterCategoryActions";
import DeleteModal from "../../Common/Modal/DeleteModal";
import PromoterCategoryControls from "./PromoterCategoryControls";
import swal from "sweetalert";
import {fetchTinyStores, fetchTinyStoresWithOperator} from "../../../actions/storesActions";
import {isPromoterPermission} from "../../../helpers/companyService";
import Papa from "papaparse";

class PromoterCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeCategoryId: null,
            newCategory: {
                id: null,
                name: '',
                companyId: null,
                salesPointIds: [],
                shared: false,
                showPriceTag: false,
            },
            companyIdFilter: '',
            currentPage: 0,
            modal: false,
            isSaveDisable: false,
            isStoresCsvInputLoading: false,
        };
        this.validators = promoterValidator(props.lang).categoryValidator;
        this.commonValidator = new CommonValidator(this.validators);
    }

    componentDidMount() {
        (async () => {
            const {lang, company, authority, location} = this.props;

            if (!isPromoterPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            await this.clearNewCategoryState();
            await this.fetchPaginatedData(0);
            if (location.state && location.state.modal) {
                await this.toggle();
            }
            await Promise.all(this.getAdditionalDataFetches());
        })();
    }

    isConflictError = response => response && response.status === 409;

    fetchPaginatedData = async currentPage => {
        const {company, authority} = this.props;
        const {companyIdFilter} = this.state;
        await this.props.fetchCategories({
            companyId: authority === SUPER_ADMIN ? companyIdFilter : company.id,
            page: currentPage
        });
        await this.setState({
            currentPage
        });
    };

    getAdditionalDataFetches = () => {
        const {authority, company} = this.props;
        if (authority === SUPER_ADMIN) {
            return [
                this.props.fetchTinyStores()
            ];
        } else if (company.types.includes('RETAIL')) {
            return [
                this.props.fetchTinyStores({companyIds: [company.id]})
            ];
        } else if (company.types.includes('OPERATOR')) {
            return [
                this.props.fetchTinyStoresWithOperator(company.id)
            ];
        }
    }

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    toggle = async () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    isOkModalToggle = id => {
        this.setState({
            isOkModal: !this.state.isOkModal,
            activeCategoryId: id
        });
    };

    onCompanyFilterClick = event => {
        this.setState({
            companyIdFilter: event.target.value
        }, () => {
            this.fetchPaginatedData(0);
        });
    }

    clearFilters = () => {
        this.setState({
            companyIdFilter: '',
        }, () => {
            this.fetchPaginatedData(0);
        })
    };

    onInputChange = event => {
        const name = event.target.name;
        const value = event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value;
        this.commonValidator.checkField(name, value);
        this.setState(state => ({
            newCategory: Object.keys(state.newCategory).reduce((res, key) => {
                if (key === name) {
                    res[key] = value;
                } else {
                    res[key] = state.newCategory[key];
                }
                return res
            }, {})
        }));
    };

    onStoresChange = stores => {
        const allOptions = stores.find(option => Array.isArray(option.value));
        const storeIds = allOptions
            ? allOptions.value
            : stores.map(sp => sp.value);
        this.setState({
            newCategory: {
                ...this.state.newCategory,
                salesPointIds: storeIds
            },
        });
    }

    onStoresCsvInput = (e) => {
        const file = e.target.files[0];

        this.setState({isStoresCsvInputLoading: true});

        if (file) {
            Papa.parse(file, {
                complete: (result) => this.handleStoresCsvInput(result.data),
                header: false,
                skipEmptyLines: true,
                worker: true,
            });
        }

        this.setState({isStoresCsvInputLoading: false});
    };

    handleStoresCsvInput = csvRows => {
        const {tinyStores, tinyStoresWithOperator, lang} = this.props;
        const newStoreNames = Array.from(new Set(csvRows.map(row => row[0])));

        const newStores = tinyStores.concat(tinyStoresWithOperator)
            .filter(s => newStoreNames.includes(s.name));
        const newStoreIds = newStores.map(s => s.id);

        const notFoundStoreNames = newStoreNames
            .filter(name => !newStores.some(store => store.name === name))
            .join('\n');

        this.setState({
            newCategory: {
                ...this.state.newCategory,
                salesPointIds: newStoreIds
            },
        });

        if (notFoundStoreNames.length) {
            swal(I18n[lang].modal.notFoundSalesPoints, notFoundStoreNames);
        }
    }

    clearNewCategoryState = async () => {
        const {company, authority} = this.props;
        this.commonValidator.resetAllErrors();
        await this.setState({
            newCategory: {
                id: null,
                name: '',
                companyId: authority !== SUPER_ADMIN ? company.id : null,
                shared: this.isCategoriesSharedByDefault(),
                showPriceTag: false,
            },
            activeCategoryId: null,
        });
    };

    isCategoriesSharedByDefault = () => {
        const {company, authority} = this.props;
        return authority === SUPER_ADMIN
            ? false
            : company.types.includes('OPERATOR')
    }

    addCategoryClick = async () => {
        await this.clearNewCategoryState();
        await this.toggle();
    };

    onEditCategory = async (id) => {
        await this.clearNewCategoryState();
        let selectedCategory = this.props.promoterCategories
            .find(item => item.id === id);
        this.setState({
            modal: !this.state.modal,
            newCategory: selectedCategory,
        });
    };

    deleteCategory = async () => {
        await this.props.deleteCategory(this.state.activeCategoryId);
        await this.fetchPaginatedData(0);
        this.setState({
            activeCategoryId: null
        }, () => this.isOkModalToggle(null))
    };

    handleSubmit = async (event) => {
        const {newCategory} = this.state;
        const {lang, promoterCategories} = this.props;
        if (event) {
            event.preventDefault();
        }
        let categories = promoterCategories || [];
        if (this.commonValidator.isValid()) {
            await this.setState({isSaveDisable: true});
            const categoryExists = categories.filter(category => category.id === newCategory.id)
                .length > 0;
            const promise = categoryExists
                ? this.props.updateCategory(newCategory)
                : this.props.saveCategory(newCategory);
            promise.then(async () => {
                await this.fetchPaginatedData(0);
                await this.clearNewCategoryState();
                await this.toggle();
            }).catch(error => {
                if (this.isConflictError(error)) {
                    swal(I18n[lang].categoryAlreadyExists, "", "error")
                }
                console.log(error.statusText);
            })
            await this.setState({isSaveDisable: false});
        }
    };

    render() {
        const {
            lang,
            authority,
            loading,
            companies,
            company,
            tinyStores,
            tinyStoresWithOperator,
            promoterCategories,
            pagination
        } = this.props;
        const {currentPage, isOkModal, newCategory, companyIdFilter, modal, isStoresCsvInputLoading} = this.state;
        const stores = tinyStores.concat(tinyStoresWithOperator);

        const promoterCategoryList = loading
            ? <div className="loading">Loading...</div>
            : <PromoterCategoryList
                lang={lang}
                companies={companies}
                categories={promoterCategories}
                currentPage={currentPage}
                onEditCategory={this.onEditCategory}
                isOkModalToggle={this.isOkModalToggle}
                setCurrentPage={this.setCurrentPage}
                totalPages={pagination.totalPages}
            />

        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <DeleteModal
                    lang={lang}
                    isOkModal={isOkModal}
                    toggle={this.isOkModalToggle}
                    onDeleteClick={this.deleteCategory}
                />
                <PromoterCategoryModal
                    lang={lang}
                    isModal={modal}
                    toggle={this.toggle}
                    newCategory={newCategory}
                    companies={companies}
                    stores={stores}
                    handleSubmit={this.handleSubmit}
                    onInputChange={this.onInputChange}
                    onStoresChange={this.onStoresChange}
                    onStoresCsvInput={this.onStoresCsvInput}
                    isStoresCsvInputLoading={isStoresCsvInputLoading}
                    validator={this.commonValidator}
                    isSaveDisable={this.state.isSaveDisable}
                    showSharedCheckbox={authority === SUPER_ADMIN || company.types.includes('OPERATOR')}
                    authority={authority}
                />
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-play-circle-outline mr-2"/>
                            {I18n.promoterTitleBeginning + I18n[lang].categories}
                        </div>
                    </CardTitle>

                    <CardBody>
                        <PromoterCategoryControls
                            lang={lang}
                            onCompanyFilterClick={this.onCompanyFilterClick}
                            authority={authority}
                            companies={companies}
                            companyId={companyIdFilter}
                            clearFilters={this.clearFilters}
                            addCategoryClick={this.addCategoryClick}
                        />
                        {promoterCategoryList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchCategories: query => dispatch(fetchPromoterCategories(query)),
        updateCategory: category => dispatch(updateSinglePromoterCategory(category)),
        saveCategory: category => dispatch(saveNewPromoterCategory(category)),
        deleteCategory: categoryId => dispatch(removePromoterCategory(categoryId)),
        fetchTinyStores: query => dispatch(fetchTinyStores(query)),
        fetchTinyStoresWithOperator: (operatorCompanyId) => dispatch(fetchTinyStoresWithOperator(operatorCompanyId)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    promoterCategories: state.promoterCategories.promoterCategories,
    pagination: state.promoterCategories.pagination,
    loading: state.promoterCategories.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    tinyStores: state.tinyStoresReducer.tinyStores,
    tinyStoresWithOperator: state.tinyStoresWithOperatorReducer.tinyStoresWithOperator,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoterCategory)


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterCategory/PromoterCategory.js